import { useQuery } from '@tanstack/react-query';
import { getApiBaseUrl } from '@/lib/api-base-url';
import { authFetch } from '@/lib/auth-fetch';

export interface AlertCounts {
  pendingApprovals: number;
  awaitingExecution: number;
  rollsDue14d: number;
  reconciliationVariance: number;
}

export class HedgingAlertsApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'HedgingAlertsApiError';
  }
}

async function fetchAlerts(): Promise<AlertCounts> {
  const response = await authFetch(`${getApiBaseUrl()}/hedging/alerts`);
  if (!response.ok) {
    throw new HedgingAlertsApiError(`Request failed (${String(response.status)})`, response.status);
  }
  return (await response.json()) as AlertCounts;
}

export const HEDGING_ALERTS_QUERY_KEY = ['hedging', 'alerts'] as const;
const REFETCH_INTERVAL_MS = 60_000;

export function useHedgingAlerts() {
  return useQuery({
    queryKey: HEDGING_ALERTS_QUERY_KEY,
    queryFn: fetchAlerts,
    refetchInterval: REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
}
